module.exports = __webpack_public_path__ + "710b3548c5870d95da04c1a76bf32c98.svg";